<template>
  <!-- 首年梯度加费 -->
  <div class="td">
    <Dropdown :visible="visible" trigger="custom" @mouseleave.native="closePreview" placement="left">
      <div class="btn" @mouseover="openPreview(true)" @click="openConfigModal('activityGradientModal', true)">
        <span v-if="topItem.sourceType == 2">{{ tableItem.isExistGrade ? '已配置' : '配置' }}</span>
        <span v-else>{{ tableItem.isExistGrade ? '查看' : '-' }}</span>
      </div>
      <template slot="list">
        <div v-for="bean in list" :key="bean.key" class="list-item">
          <div class="tools-box" style="width: 600px">
            <span>费用项名称：{{ bean.expenseItem }}</span>
            <span>费用有效期：{{ bean.expenseStartTime }}至{{ bean.expenseEndTime }}</span>
          </div>
          <div class="tools-box pd0" style="width: 600px">
            <span>条件方案：{{ bean.programNames.join('，') }}</span>
          </div>
          <div class="table" style="width: 600px">
            <div class="tr">
              <div class="td th td1">
                条件方案
                <p class="info-text" v-if="bean.conditionType == 1">(X=累计规模保费)</p>
                <p class="info-text" v-if="bean.conditionType == 2">(X=累计标准保费)</p>
              </div>
              <div class="table-box td23">
                <div class="tr">
                  <div class="td th td2">目标方案</div>
                  <div class="td th td3">费用率（%）</div>
                </div>
              </div>
            </div>
            <div class="tr" v-for="row in bean.gradientItemList" :key="row.key">
              <div class="td td1" v-if="row.conditionStart&&row.conditionEnd&&row.conditionStart!=row.conditionEnd">
                <span>{{ row.conditionStart }}</span>
                <span v-if="row.conditionStartSymbol == 1">{{ '<' }}</span>
                <span v-if="row.conditionStartSymbol == 2">{{ '≤' }}</span>
                <span>X</span>
                <span v-if="row.conditionEndSymbol == 1">{{ '<' }}</span>
                <span v-if="row.conditionEndSymbol == 2">{{ '≤' }}</span>
                <span>{{ row.conditionEnd }}</span>
              </div>
              <div class="td td1" v-else-if="row.conditionStart == row.conditionEnd">
                <span>X</span>
                <span>=</span>
                <span>{{ row.conditionEnd }}</span>
              </div>
              <div class="td td1" v-else-if="!row.conditionEnd">
                <span>X</span>
                <span>≥</span>
                <span>{{ row.conditionStart }}</span>
              </div>
              <div class="table-box td23">
                <div class="tr" v-for="item in row.programCommissionList" :key="item.key">
                  <div class="td td2">{{ item.programNames.join('，')||'-' }}</div>
                  <div class="td td3">{{ item.commission||'-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="list.length == 0">
          <!-- 商户的团险-->
          <!-- <div class="empty-item" v-if="topItem.productCategory != 3 && topItem.sourceType == 2">该配置暂未开放，请耐心等待</div> -->
          <!-- 非商户的团险 -->
          <div class="empty-item">未配置</div>
        </template>
      </template>
    </Dropdown>
  </div>
</template>
  
<script>
import activityGradient from './activityGradient.config.js';
import common from './common.config.js';
export default {
  mixins: [activityGradient, common],
  components: {},
  props: {
    tableItem: null,
    topItem: null
  },
  data() {
    return {
      visible: false,
      over: false,//是否停留
      timer: null,
      list: []
    };
  },
  computed: {},
  created() {},
  methods: {
    // 新增费用行
    addCommission(list) {
      const key = Date.now();
      list.push({ key: 'b' + key, programIds: [], programNames: [], commission: '' });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.table {
  .td1 {
    flex: 300px;
  }
  .td2 {
    flex: 200px;
  }
  .td3 {
    flex: 100px;
  }
  .td23 {
    flex: 300px;
  }
}
</style>  